import { buildLandingHighlights, buildLandingPages } from "@plaatplan/i18n";
import { useMemo } from "react";
import { useLocale } from "./useLocale.js";

export function useLandingPages() {
  const { preferences } = useLocale();
  return useMemo(
    () => buildLandingPages(preferences.locale),
    [preferences.locale],
  );
}

export function useLandingHighlights() {
  const { preferences } = useLocale();
  return useMemo(
    () => buildLandingHighlights(preferences.locale),
    [preferences.locale],
  );
}
